<div class="container-fluid p-3">
  <div
    class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-3 flex-wrap">
    <!-- Title aligned to the right on larger screens -->
    <h4 class="m-0 text-md-end text-start text-color fs-24 fg-500">
      {{ 'ADMIN.PROFESSORS' | translate }}
    </h4>

    <!-- Ajout : action de l'écran, hors de la barre de filtres. Elle ne dépend
         d'aucune facette — parcours et matière se choisissent dans le modal. -->
    <app-button *ngIf="canWrite" (click)="addProfessor()" [label]="'ADMIN.ADD_PROFESSOR' | translate"
      [customClasses]="'fs-14 fg-600 py-2 px-5 btn-create-test'" [type]="'button'" />
  </div>

  <!-- Filtres : mêmes principes que la banque de questions (facettes cumulables,
       entrée « tout » par défaut, compteur, remise à zéro). -->
  <app-filter-bar class="mb-4 d-block"
    [activeCount]="activeFilterCount"
    [resultCount]="visibleProfessors.length"
    [totalCount]="professors.length"
    [search]="search"
    searchLabelKey="FILTERS.SEARCH_PROFESSOR"
    searchPlaceholderKey="FILTERS.SEARCH_PROFESSOR_PLACEHOLDER"
    (searchChange)="onSearchChange($event)"
    (reset)="resetFilters()">

    <app-searchable-select
      [options]="pathOptions" [value]="selectedPathId"
      [allLabel]="'FILTERS.ALL_PATHS' | translate"
      [placeholder]="'ADMIN.SELECT_PATH' | translate" icon="fa-solid fa-route"
      [disabled]="isLoadingPaths"
      (valueChange)="onPathChange($event)">
    </app-searchable-select>

    <app-searchable-select
      [options]="subjectOptions" [value]="selectedSubjectId"
      [allLabel]="'FILTERS.ALL_SUBJECTS' | translate"
      [placeholder]="'ADMIN.SELECT_SUBJECT' | translate" icon="fa-solid fa-book"
      [disabled]="isLoadingSubjects || subjectOptions.length === 0"
      (valueChange)="onSubjectChange($event)">
    </app-searchable-select>
  </app-filter-bar>

  <!-- Professors Table -->
  <app-custom-tab [data]="visibleProfessors" [columns]="professorColumns"
    [actionTemplate]="professorActionsTemplate"
    [toolbar]="tableToolbar" [filteredByCaller]="activeFilterCount > 0"
    [locale]="currentLocale" [enableRtl]="isRTL" (rowClick)="handleRowClick($event)" (edit)="onEditProfessor($event)"
    (delete)="onDeleteProfessor($event)" (show)="onShowProfessor($event)">

    <!-- Actions template -->
    <ng-template #professorActionsTemplate let-data>
      <button *ngIf="canWrite" class="btn btn-sm btn-primary mx-1" (click)="onEditProfessor(data)"
        title="{{ 'COMMON.EDIT' | translate }}">
        <i class="fa-solid fa-pen-to-square"></i>
      </button>
      <button *ngIf="canWrite" class="btn btn-sm btn-danger mx-1" (click)="onDeleteProfessor(data)"
        title="{{ 'COMMON.DELETE' | translate }}">
        <i class="fa-solid fa-trash-can"></i>
      </button>
      <button class="btn btn-sm btn-secondary mx-1" (click)="onShowProfessor(data)"
        title="{{ 'COMMON.VIEW' | translate }}">
        <i class="fa-solid fa-eye"></i>
      </button>
      <!-- Compte d'accès : création à la demande, distincte de la création de la fiche -->
      <button *ngIf="canWrite && !hasAccount(data)" class="btn btn-sm btn-success mx-1" (click)="onCreateAccount(data)"
        [disabled]="creatingAccountFor === data.id"
        title="{{ 'ADMIN.CREATE_ACCOUNT' | translate }}">
        <i class="fa-solid" [ngClass]="creatingAccountFor === data.id ? 'fa-spinner fa-spin' : 'fa-user-plus'"></i>
      </button>
      <span *ngIf="hasAccount(data)" class="badge bg-success-subtle text-success mx-1"
        title="{{ 'ADMIN.ACCOUNT_EXISTS' | translate }}">
        <i class="fa-solid fa-circle-check"></i>
      </span>
    </ng-template>
  </app-custom-tab>
</div>

<!-- ADD/EDIT PROFESSOR MODAL -->
<app-modal [title]="(isEditMode ? 'BUTTONS.EDIT' : 'ADMIN.ADD_PROFESSOR') | translate" [size]="'lg'"
  [show]="showProfessorModal" [hasFooter]="false" (closed)="onModalClosed()">
  <app-add-professor [isEditMode]="isEditMode" [professor]="selectedProfessor" [subjectId]="selectedSubjectId"
    [learningPathId]="selectedPathId" [learningPaths]="learningPaths"
    (saved)="handleProfessorSaved($event)" (cancelled)="onModalClosed()">
  </app-add-professor>
</app-modal>
